import { render, staticRenderFns } from "./ProviderListNew.vue?vue&type=template&id=332dcca8"
import script from "./ProviderListNew.vue?vue&type=script&lang=js"
export * from "./ProviderListNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports